import { useCallback, useEffect, useRef } from 'react'

export const useAnimationFrame = (callback: () => void): (() => void) => {
  const animationFrameRef = useRef<number | null>(null)

  const animate = useCallback(() => {
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current)
    }
    animationFrameRef.current = requestAnimationFrame(callback)
  }, [callback])

  useEffect(() => {
    animate()

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current)
      }
    }
  }, [animate])

  return animate
}
